import EditorCollapseIcon from '@atlaskit/icon/glyph/editor/collapse';
import EditorExpandIcon from '@atlaskit/icon/glyph/editor/expand';
import { actionButton } from './button.styles';
import Tooltip from '@atlaskit/tooltip';

interface SidebarToggleProps {
  expanded: boolean;
  onToggle: () => void;
}

export const SidebarToggle = ({ expanded, onToggle }: SidebarToggleProps) => {
  return (
    <Tooltip
      content={(expanded ? 'Collapse' : 'Expand') + ' templates and tips'}
      position="top"
    >
      {(tooltipProps) => (
        <button
          css={actionButton(expanded)}
          {...tooltipProps}
          onClick={onToggle}
        >
          {expanded ? (
            <EditorCollapseIcon label="Collapse templates and tips" />
          ) : (
            <EditorExpandIcon label="Expand templates and tips" />
          )}
        </button>
      )}
    </Tooltip>
  );
};
